import { Tooltip, Box } from '@mui/material';
import map from 'lodash.map';
import React from 'react';
import { Cloner } from '../hooks/Cloner';

const TableList = ({
  text: value,
  valuesSource,
  component: child,
  toolTip = false,
  toolTipPlacement = 'bottom',
  uniqueValuesOnly = true,
}) => {
  let values = map(value, valuesSource, []);
  values = uniqueValuesOnly ? Array.from(new Set(values)) : values;

  const [firstValue = ''] = values;
  const text =
    values.length <= 1 ? firstValue : `${firstValue}, (${values.length - 1}+)`;

  return toolTip ? (
    <Tooltip arrow title={values.join(', ')} placement={toolTipPlacement}>
      <Box>{child ? Cloner(child, text) : text}</Box>
    </Tooltip>
  ) : (
    <>{child ? Cloner(child, text) : text}</>
  );
};

export default TableList;
